import React, { useState } from 'react';

import { NavbarTop } from './components/Navbar/NavbarTop';
import { ContentContainer } from './components/ContentContainer/ContentContainer';
import { GlobalStyle } from './styles.App';

export default function App() {
  const [currentSection, setCurrentSection] = useState('');

  return (
    <>
      <GlobalStyle />
      <NavbarTop currentSection={currentSection} />
      <ContentContainer
        currentSection={currentSection}
        setCurrentSection={setCurrentSection}
      />
    </>
  );
}
